import tingle from 'tingle.js';
import "./../assets/style.css";

export default class Modal {
    constructor(api, message, onCloseCallback) {
        this.api = api;
        // {
        //     "languageCode": "ENG",
        //     "title": "Test message",
        //     "body": "This is a message generated from a test case.",
        //     "prohibitGameplay": true
        // }
        this.message = message;
        // instanciate new modal
        this.modal = new tingle.modal({
            footer: true,
            stickyFooter: false,
            closeMethods: ['button'],
            closeLabel: "Close",
            // cssClass: ['custom-class-1', 'custom-class-2'],
            // onOpen: () => {
            // },
            onClose: onCloseCallback,
            beforeClose: () => {
                // here's goes some logic
                // e.g. save content before closing the modal
                return true; // close the modal
            }
        });
    }

    async showModal() {
        try {
            await this.api.util.loadGameBridgeCSS();
            // set content
            this.modal.setContent('<h1>' + this.message.title + '</h1><span>' + this.message.body + '</span>');
            if(!this.message.prohibitGameplay) {
                if(this.message.cta) {
                    this.message.cta.forEach(element => {
                        if(element.actionType === "REDIRECT") {
                            // add a button
                            this.modal.addFooterBtn(element.label, 'tingle-btn tingle-btn--primary', () => {
                                // here goes some logic
                                window.location.href = decodeURIComponent(element.url);
                                this.modal.close();
                            });  
                            
                        } else if (element.actionType === "CLOSE") {
                            // add a button
                            this.modal.addFooterBtn(element.label, 'tingle-btn tingle-btn--secondary', () => {
                                this.modal.close();
                            }); 
                        }
                    });
                } else {
                    // add a button
                    this.modal.addFooterBtn('Ok', 'tingle-btn tingle-btn--primary', () => {
                        // here goes some logic
                        this.modal.close();
                    });
                }
            }

            // add another button
            // this.modal.addFooterBtn('Cancel !', 'tingle-btn tingle-btn--secondary', () => {
            //     // here goes some logic
            //     this.modal.close();
            // });
            this.modal.open();
        } catch (e) {
            console.log("error modal: ", e);
        }
    }
}
